import { useMemo } from 'react';
import { prop, pick } from 'ramda';
import { useParams } from 'react-router-dom';
import { htcmdService } from 'js/services/htcmd.service';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import { LOTTO_OVERLAYS_ID } from '../constants';

export const useGetInitParams = () => {
    const { pathLang } = useParams<{pathLang?: string}>();
    const lang = useUserSelector(prop('lang'));
    const {
        defaultLocale,
        defaultCurrency,
        lottoRootURL,
        lottoConfigNameToLoad
    } = useAppSelector(pick(['defaultLocale', 'defaultCurrency', 'lottoRootURL', 'lottoConfigNameToLoad']));

    return useMemo(() => ({
        APIVersion: 4,
        uiContext: htcmdService.isEnabled || htcmdService.isWrapperEnabled ? 'native' : null,
        language: (lang || defaultLocale).replace('_', '-'),
        currencyCode: defaultCurrency,
        getSessionInfoFn: async () => null,
        overlayContainerId: LOTTO_OVERLAYS_ID,
        routingPrefix: pathLang ? `/${pathLang}${lottoRootURL}` : lottoRootURL,
        showHomePageOnForeignUrl: true,
        ...lottoConfigNameToLoad ? { configNameToLoad: lottoConfigNameToLoad } : {}
    }), [
        lang,
        pathLang,
        defaultCurrency,
        defaultLocale,
        lottoConfigNameToLoad,
        lottoRootURL
    ]);
};
